import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  AddEstimateGrantInput,
  AddEstimateGrantMutation as AddEstimateGrantMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { hydrateEstimateCaches } from './hydrateEstimateCaches';

const AddEstimateGrantMutation = graphql(`
  mutation AddEstimateGrant($input: AddEstimateGrantInput!) {
    addEstimateGrant(input: $input) {
      ...EstimateBuilderEstimate
      preview {
        template
        context
      }
    }
  }
`);

const useAddEstimateGrant = (args: {
  projectId: string;
  estimateId: string;
  options?: UseMutationOptions<
    AddEstimateGrantMutationResult,
    Error,
    AddEstimateGrantInput
  >;
}) => {
  const { projectId, estimateId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation<
    AddEstimateGrantMutationResult,
    Error,
    AddEstimateGrantInput
  >({
    mutationFn: (input) =>
      gqlClient.request(AddEstimateGrantMutation, { input }),
    onSuccess: (data, variables, context) => {
      hydrateEstimateCaches(queryClient, {
        projectId,
        estimateId,
        estimate: data.addEstimateGrant,
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useAddEstimateGrant;
